import { I18nt } from 'utils';
import styles from './CitaBox.module.less';
import { useHistorialCitas } from '../../HistorialCitasContext';
import {
	ClockCircleFilled,
	CheckCircleFilled,
	CloseCircleFilled,
	StopFilled,
} from '@ant-design/icons';
import { CitaProps } from 'utils/interfaces';
import { Button } from 'antd';

const CitaBox = ({
	cita,
	isCancelVisible,
}: {
	cita: CitaProps;
	isCancelVisible?: boolean;
}) => {
	const { dispatch } = useHistorialCitas();

	const stateMap = () => {
		if (cita.estadostr === 'Pendiente') {
			return (
				<div className={styles.scheduled}>
					<ClockCircleFilled />
					<p>{I18nt('programada')}</p>
				</div>
			);
		}
		if (cita.estadostr === 'Asistio') {
			return (
				<div className={styles.completed}>
					<CheckCircleFilled />
					<p>{I18nt('completada')}</p>
				</div>
			);
		}
		if (cita.estadostr === 'Perdida') {
			return (
				<div className={styles.lost}>
					<CloseCircleFilled />
					<p>{I18nt('perdida')}</p>
				</div>
			);
		}
		if (cita.estadostr === 'Anulada') {
			return (
				<div className={styles.canceled}>
					<StopFilled />
					<p>{I18nt('cancelada')}</p>
				</div>
			);
		}
	};

	const [fecha, hora, indicador] = cita.fechaHora.split(' ');
	const horaCompleta = `${hora}${indicador}`;
	return (
		<div className={styles.citaBox}>
			<div className={styles.mobileStateBox}>
				<div className={styles.mobileCreated}>
					<p>{`${I18nt('creado')}: ${fecha}`}</p>
				</div>
				<div className={styles.mobileState}>{stateMap()}</div>
			</div>
			<div className={styles.borderBox}>
				<div className={styles.place}>
					<p>{`${I18nt('lugar')}:`}</p>
					<p>{cita.establecimiento}</p>
				</div>
				<div className={styles.doctor}>
					<p>{`${I18nt('medico')}:`}</p>
					<p>{cita.medico || I18nt('general')}</p>
				</div>
				<div className={styles.specialty}>
					<p className={cita.medico ? styles.specialDr : styles.generalDr}>
						{cita.medico ? cita.especialidad : I18nt('general')}
					</p>
				</div>
				<div className={styles.date}>
					<p>{`${I18nt('fecha')}:`}</p>
					<p>{fecha}</p>
				</div>
				<div className={styles.hour}>
					<p>{`${I18nt('hora')}:`}</p>
					<p>{horaCompleta}</p>
				</div>
				<div className={styles.createdAt}>
					<p>{`${I18nt('creado')}:`}</p>
					<p>{cita.fechaCreacion}</p>
				</div>
				<div className={styles.state}>{stateMap()}</div>
				<div className={styles.cancel}>
					{isCancelVisible ? (
						<Button
							type='link'
							onClick={() =>
								dispatch({
									type: 'setIdCita',
									payload: `${cita.idCita}`,
								})
							}
						>
							{I18nt('cancelar_cita')}
						</Button>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default CitaBox;
